import type { RequestOptions } from '@@/plugin-request/request';
import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { message } from 'antd';

const TOKEN_KEY = 'admin_token';

export const errorConfig: RequestConfig = {
  errorConfig: {
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;

      if (error.response) {
        message.error(`请求异常：${error.response.status}`);
        return;
      }

      if (error.request) {
        message.error('请求无响应，请重试');
        return;
      }

      message.error('请求异常，请重试');
    },
  },

  requestInterceptors: [
    (config: RequestOptions) => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) {
        return { ...config };
      }

      return {
        ...config,
        headers: {
          ...(config.headers || {}),
          Authorization: `Bearer ${token}`,
        },
      };
    },
  ],

  responseInterceptors: [
    (response) => {
      const payload = (response as any)?.data;
      if (payload?.code === -1) {
        localStorage.removeItem(TOKEN_KEY);
        if (history.location.pathname !== '/user/login') {
          history.replace('/user/login');
        }
      }
      return response;
    },
  ],
};
